
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CertificatesInventoryContent } from '@/components/admin/certificates/CertificatesInventoryContent';

export default function CertificatesInventory() {
  return (
    <AdminLayout>
      <CertificatesInventoryContent />
    </AdminLayout>
  );
}
